import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createUserReceiptDetailsSlice = (set, get) => ({
    userReceiptDetails: {
        loading: false,
        data: []
    },
    getUserReceiptDetails: async (InsuranceRequestId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ userReceiptDetails: { ...state.userReceiptDetails, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/payment/receipt/${InsuranceRequestId}/Info`,
                headers: { token }
            });
            set(() => ({ userReceiptDetails: { loading: false, data: resp.data } }));
        } catch (error) {
            set(() => ({ userReceiptDetails: { loading: false, data: [] } }));
        }
    }
});
